export const pageTitles = {
    '/': 'Olivia Knestaut | Portfolio',
    '/case-studies': 'Case Studies | Olivia Knestaut',
    '/about': 'About | Olivia Knestaut',
    '/resume': 'Resume | Olivia Knestaut',
    '/photography': 'Photography | Olivia Knestaut',
    '/design': 'Design & Media | Olivia Knestaut',
    '/accessibility': 'Accessible Portfolio Case Study | Olivia Knestaut',
    '/righton': 'RightOn Education Case Study | Olivia Knestaut',
    '/kims-dragon': "Kim's Dragon Case Study | Olivia Knestaut",
    '/letterboxd': 'Microinteraction Design Case Study | Olivia Knestaut',
    '/intealth': 'Intealth Modern Apps Case Study | Olivia Knestaut',
    '/branding': 'Brand Board | Olivia Knestaut',
};

export const caseStudyMeta = {
    '/accessibility': { color: 'var(--accent-green)' },
    '/righton': { color: 'var(--accent-purple)' },
    '/kims-dragon': { color: 'var(--accent-red)' },
    '/letterboxd': { color: 'var(--accent-blue)' },
    '/intealth': { color: 'var(--accent-blue)' },
};

export const caseStudyRoutes = Object.keys(caseStudyMeta);
